/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
const s = (t) => {
  const e = r.useRef();
  return r.useEffect(() => {
    e.current = t;
  }), e.current;
};
export {
  s as usePrevious
};
